export default __webpack_public_path__ + "static/Wendy_Ashlock-5f7e7225294a2933ef5e307240d08085.jpg";